/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import NewUser from "../users/newUser";
import DataTable from "../../../examples/Tables/DataTable";
import data from "../../dashboard/components/Projects/data";
import { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import PermissionControl from "../../../components/Utils/PermissionControl";


function MerchantUsers(props) {
  const {merchant, openConfigurator, setOpenConfigurator, user, setUser, refreshMerchant} = props;
  const { merchatnUsersTablecolumns } = data();

  const [users, setUsers] = useState([]);

  function updateUserHandler(item) {
    console.log(item)
    setUser({});
    setOpenConfigurator(true);
    setUser(item);
  }

  function handleConfirmDelete(item) {
    return;
  }

  useEffect(() => {
    const modifiedData = merchant.users.map(item => {
      const action = (
          <PermissionControl permission={{ restrict: true, module: "User", subModule: "UpdateMerchantUser" }}>
            <MDBox display="flex" alignItems="center" lineHeight={1}>
              <Icon fontSize="small" style={{cursor : 'pointer'}} onClick={(e) => { e.stopPropagation(); updateUserHandler(item); }}>create</Icon>
              {/*<Icon fontSize="small" style={{cursor : 'pointer'}} onClick={() => handleConfirmDelete(item)}>delete</Icon>*/}
            </MDBox>
          </PermissionControl>
      );
      return { ...item, action };
    });
    setUsers(modifiedData);
  }, [merchant])

  return (
      <Grid mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <MDBox sx={(theme) => ({ border: `1px solid ${theme.palette.grey[300]}`, borderRadius: "8px", background: theme.palette.white.main, overflow: "hidden" })}>
              <DataTable
                table={{ columns : merchatnUsersTablecolumns, rows : users }}
                showTotalEntries={true}
                isSorted={true}
                noEndBorder
                entriesPerPage={true}
                entriesPerPagePosition="bottom"
                canSearch={false}
              />
            </MDBox>
          </Grid>
          <NewUser openConfigurator={openConfigurator} setOpenConfigurator={setOpenConfigurator} merchant={merchant} user={user} refreshMerchant={refreshMerchant} />
        </Grid>
      </Grid>
  );
}

MerchantUsers.defaultProps = {
  merchant: false,
  openConfigurator: false,
  user: {},
}

MerchantUsers.propTypes = {
  merchant: PropTypes.any.isRequired,
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func.isRequired,
  user: PropTypes.any,
  setUser: PropTypes.func.isRequired,
  refreshMerchant: PropTypes.func.isRequired,
}

export default MerchantUsers;
